module.exports = __webpack_public_path__ + "static/media/3.16_preview.d98d682b.png";